import React from 'react'
import { Navbar} from '../components'
import Terms from '../components/Terms'

const TermsPage = () => {
  return (
    <div>
        <Navbar />
        <Terms />
    </div>
  )
}

export default TermsPage